// simply includes jQuery current version from NPM
window.jQuery = require("jquery");